import React from "react";
import { Pressable } from "react-native";
import { YStack, XStack, Text } from "tamagui";
import Avatar from "../../../../components/Avatar";
import { ArrowRightIcon } from "../../../../components/design-system/icons/ArrowRightIcon";
import { Attendance } from "../../../../types/event";
import { getAttendeePreviewText } from "../../../../utils/formatNames";

type EventDetailAttendeesPreviewProps = {
  attendees: Attendance[];
  onPress: () => void;
};

export const EventDetailAttendeesPreview = ({
  attendees,
  onPress,
}: EventDetailAttendeesPreviewProps) => {
  const displayedAttendees = attendees.slice(0, 4);
  const remainingCount = attendees.length - 4;

  return (
    <YStack gap="$2" mb="$4" px="$4" mt="$4">
      <Text fontFamily="$heading" fontSize={16} textTransform="uppercase">
        Attendees
      </Text>
      <Pressable onPress={onPress}>
        <XStack justifyContent="space-between" alignItems="center">
          <XStack gap={2} alignItems="center">
            {displayedAttendees.map((attendee) => (
              <Avatar
                key={attendee.id}
                size={40}
                url={attendee.avatar_url ?? null}
                imageStyle={{ borderRadius: 999 }}
              />
            ))}

            {remainingCount > 0 ? (
              <Text textTransform="uppercase">
                +{remainingCount} {remainingCount === 1 ? "other" : "others"}
              </Text>
            ) : null}
          </XStack>

          <ArrowRightIcon width={20} height={20} />
        </XStack>
      </Pressable>
      <Text fontSize={12} color="$brandGray" w="75%">
        {getAttendeePreviewText(
          displayedAttendees.map((attendee) => attendee.name)
        )}
      </Text>
    </YStack>
  );
};
